import React, { useEffect, useState } from "react";
import { Navigate, Route, useLocation, useNavigate } from "react-router-dom";
import appLogo from "../assets/images/logo/logo+orange.png";
import { useCurrentUser } from "../slices/auth/hooks";
import _ from "lodash";
import { useDispatch } from "react-redux";
import { DASHBOARD_USER_ROLES } from "../constants";

const AuthProtected = (props) => {
  const currentUser = useCurrentUser();

  const dispatch = useDispatch();
  const location = useLocation();
  const navigate = useNavigate();

  const [loading, setLoading] = useState(false);
  const isOnboardingPage = location.pathname.startsWith("/onboarding");

  useEffect(() => {
    const verifyAuthAndRedirect = async () => {
      try {
        if (!currentUser) {
          navigate("/login");
          return;
        }

        if (!currentUser.onboardingCompleted) {
          navigate("/onboarding");
        }
        if (isOnboardingPage && currentUser.onboardingCompleted) {
          if (
            currentUser.role === DASHBOARD_USER_ROLES.GA ||
            currentUser.role === DASHBOARD_USER_ROLES.BROKER
          ) {
            navigate("/profile?onboarding-completed=true");
          } else {
            navigate("/profile");
          }
        }
        setLoading(false);
      } catch (error) {
        console.log(error);
        setLoading(false);
      }
    };

    verifyAuthAndRedirect();
  }, [currentUser, dispatch, navigate]);

  if (loading) {
    <div
      style={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        height: "100vh",
        width: "100vw",
        flexDirection: "column",
      }}
    >
      <img
        src={appLogo}
        alt="baxrx-logo"
        border="0"
        style={{ width: "50vw", maxWidth: "320px" }}
      />

      <span>Loading..</span>
    </div>;
  }

  // useEffect(() => {
  //   if (currentUser && !isProfileComplete && !isProfilePage && !isLoginPage) {
  //     Swal.fire({
  //       title: "Profile Incomplete",
  //       text: "Please complete your profile to continue",
  //       icon: "warning",
  //       confirmButtonText: "Ok",
  //     }).then((result) => {
  //       if (result.value) {
  //         navigate("/onboarding");
  //       }
  //     });
  //   }
  // }, [currentUser, navigate, isProfilePage, isLoginPage]);

  if (!currentUser) {
    return <Navigate to="/login" replace />;
  }

  // if (!isProfileComplete && !isProfilePage && !isLoginPage) {
  //   return <Navigate to="/profile" replace />;
  // }

  return <>{props.children}</>;
};

const AccessRoute = ({ component: Component, ...rest }) => {
  return (
    <React.Suspense fallback={<div />}>
      <Route
        {...rest}
        render={(props) => {
          return (
            <>
              {" "}
              <Component {...props} />{" "}
            </>
          );
        }}
      />
    </React.Suspense>
  );
};

export { AccessRoute, AuthProtected };
